/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { GuidanceOptions } from "./GuidanceOptions";
export const GuidanceApiUpdateData = core.serialization.object({
    options: GuidanceOptions,
});
